import { atom, action } from 'nanostores';

export const appContainerFadedOutStore = atom<boolean>(false);
export const setAppContainerFadedOut = action(
  appContainerFadedOutStore,
  'setAppContainerFadedOut',
  (store: typeof appContainerFadedOutStore, fadedOut: boolean) => {
    store.set(fadedOut);
    return store.get();
  },
);

export const appContainerOutletRenderedStore = atom<boolean>(true);
export const setAppContainerOutletRendered = action(
  appContainerOutletRenderedStore,
  'setAppContainerOutletRendered',
  (store: typeof appContainerOutletRenderedStore, rendered: boolean) => {
    store.set(rendered);
    return store.get();
  },
);
